export default {
  "content": "<path d=\"M16.896 1H7.518v16h9.38V1z\" stroke=\"#3F4450\" stroke-width=\"1.172\" stroke-linejoin=\"round\"/><path d=\"M7.517 4.31H1.448V17h6.07V4.31z\" stroke=\"#3F4450\" stroke-width=\"1.172\" stroke-linejoin=\"round\"/><path d=\"M3.948 7.88V6.81h1.07v1.07h-1.07zm6.069-3.31V3.5h1.07v1.07h-1.07zm3.311 0V3.5h1.069v1.07h-1.07zm-9.38 6.62v-1.069h1.07v1.07h-1.07zm6.069-3.31V6.81h1.07v1.07h-1.07zm3.311 0V6.81h1.069v1.07h-1.07zm-9.38 6.62v-1.068h1.07V14.5h-1.07zm6.069-3.31v-1.069h1.07v1.07h-1.07zm3.311 0v-1.069h1.069v1.07h-1.07zm-3.311 3.31v-1.068h1.07V14.5h-1.07zm3.311 0v-1.068h1.069V14.5h-1.07z\" fill=\"#3F4450\" stroke=\"#3F4450\" stroke-width=\".586\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};